import { render, staticRenderFns } from "./regisTenagaMedis.vue?vue&type=template&id=58ae374e"
import script from "./regisTenagaMedis.vue?vue&type=script&lang=js"
export * from "./regisTenagaMedis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QCardActions,QIcon,QBanner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QCardActions,QIcon,QBanner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
